import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import { IconSeeker } from '@ui-seeker/core'

import { dsColorNew } from '@palette'
import { cellLine } from 'Pages/AnalyzersV2/@services/carPick'


/**
 * The one line beside the Cars field (UX Obs. 4): with All, an amber "Minimum across N categories — pick a car to
 * compare like with like." where "pick a car" opens the field's menu; with cars, in grey, what each cell is.
 */
export default function CarPickLine({ pick, resolved, tab, mix, isPosition, onOpen }) {
	const line = cellLine({ pick, resolved, tab, mix, isPosition })
	if (!line) return null
	if (line.tone === 'info') {
		// several cars: cut at three with "+N", the whole list on hover (v1.2)
		return <Typography title={line.title} sx={{ fontSize: 13, color: dsColorNew.textMuted, minWidth: 0 }}>{line.text}</Typography>
	}
	return <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minWidth: 0 }}>
		<IconSeeker icon="triangle-exclamation" sx={{ fontSize: 13, color: dsColorNew.warningBar }}/>
		<Typography sx={{ fontSize: 13, color: dsColorNew.textDark }}>
			{line.text}
			<Button variant="text" size="small" onClick={onOpen}
				sx={{ textTransform: 'none', p: '0 2px', minWidth: 0, fontSize: 13, verticalAlign: 'baseline', lineHeight: 'inherit' }}>{line.action}</Button>
			{line.tail}
		</Typography>
	</Box>
}
